import GdprConsent from "../gdpr/index";

const gdprNode = document.querySelector('[data-component="GdprConsent"]');

if (gdprNode !== null) {
    let props = gdprNode.getAttribute("data-props");
    if (props) props = JSON.parse(props);

    new GdprConsent(gdprNode, props);
}
